import React, { useMemo } from 'react';
import { Wrapper } from '../../atoms/wrapper';
import { PostContainer } from '../../organism/PostContainer';
import { Section } from '../../enums/container';
import * as styles from './news_section.module.sass';
import { LastNewsProps } from './type/props';
import { Post } from '../../../api/content/blog/type/post';

export const LastNewsSection = React.memo((props: LastNewsProps) => {
  const posts = useMemo(() => {
    return props.posts.map((post: Post) => <PostContainer key={`${post.slug}-${post.id}`} post={post} />);
  }, [props.posts]);

  return (
    <Wrapper section={Section.LASR_NEWS} heading_left>
      <h2 className={styles.news_head}>{props.title}</h2>
      <div className={styles.posts_wrapper}>{posts}</div>
    </Wrapper>
  );
});
